<template>
    <div class="box">
        <h2>Mena ponuky</h2>
        <div class="jazyky">
            <div class="check">
                <label class="check_container">
                    <input
                        type="radio"
                        name="currency"
                        @click="changeCurrency(1)"
                        :checked="currency == 1 ? 'checked' : ''"
                    />
                    <span class="check_checkmark"></span>
                </label>
                <span
                    class="check_txt"
                    style="cursor: pointer"
                    @click="changeCurrency(1)"
                >
                    € (EUR)
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input
                        type="radio"
                        name="currency"
                        @click="changeCurrency(2)"
                        :checked="currency == 2 ? 'checked' : ''"
                    />
                    <span class="check_checkmark"></span>
                </label>
                <span
                    class="check_txt"
                    style="cursor: pointer"
                    @click="changeCurrency(2)"
                >
                    $ (USD)
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input
                        type="radio"
                        name="currency"
                        @click="changeCurrency(3)"
                        :checked="currency == 3 ? 'checked' : ''"
                    />
                    <span class="check_checkmark"></span>
                </label>
                <span
                    class="check_txt"
                    style="cursor: pointer"
                    @click="changeCurrency(3)"
                >
                    £ (GBP)
                </span>
            </div>
            <div class="check">
                <label class="check_container">
                    <input
                        type="radio"
                        name="currency"
                        @click="changeCurrency(4)"
                        :checked="currency == 4 ? 'checked' : ''"
                    />
                    <span class="check_checkmark"></span>
                </label>
                <span
                    class="check_txt"
                    style="cursor: pointer"
                    @click="changeCurrency(4)"
                >
                    Kč (CZK)
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from './EventBus';
export default {
    props: ["offer_uuid", "currency_data"],
    data() {
        return {
            currency: null,
        };
    },
    created() {
        this.currency = this.currency_data ? this.changeCurrency : 1;
        setTimeout(() => {
            this.emitCurrency();
        }, 500);
    },
    methods: {
        emitCurrency(){
            let currency = "€";
            if(this.currency == 1) {
                currency = "€";
            }else if(this.currency == 2) {
                currency = "$";
            }else if(this.currency == 3) {
                currency = "£";
            }else if(this.currency == 4) {
                currency = "Kč";
            }
            EventBus.$emit('currencyChanged', currency);
        },
        changeCurrency: _.debounce(function (val) {
            this.currency = val;
            axios
                .post(`/api/offers/offer/currency/change`, {
                    offer_uuid: this.offer_uuid,
                    currency: this.currency,
                })
                .then((response) => {});
            this.emitCurrency();
        }, 200),
    },
    watch: {
        currency_data() {
            this.currency = this.currency_data;
            this.emitCurrency();
        },
    },
};
</script>

<style lang="scss" scoped>
.jazyky {
    display: flex;
    width: 90%;
    gap: 30px;
    align-items: center;
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}
.box {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 4px;
    padding: 30px 0 15px 0;
    @media screen and (max-width: 700px) {
        display: block;
        text-align: center;
        padding-bottom: 10px;
    }
    h2 {
        @media screen and (max-width: 700px) {
            margin-bottom: 10px;
        }
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
        margin-bottom: 0;
        span {
            margin: 0 5px;
            color: #f3385a;
        }
        @media screen and (max-width: 700px) {
            width: fit-content;
            margin: 0 auto;
        }
        @media (max-width: 600px) {
            margin: 0 auto 0 0;
        }
    }
}
.check {
    position: relative;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 16px;
    margin-top: 15px;
    span.check_txt {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }
    &:hover {
        .tooltip_jazyk {
            opacity: 1 !important;
        }
    }
    .tooltip_jazyk {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 125px;
        background: #f3385a;
        box-shadow: 0px 2px 2px rgb(143 153 179 / 20%);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: -50px;
        right: -1px;
        z-index: 10000;
        transition: opacity 0.5s ease-in-out;
        &::after {
            content: "";
            width: 15px;
            height: 15px;
            background: #f3385a;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }
    .check_container {
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .check_container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .check_checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #ffffff;
        border: 1px solid #212541;
        border-radius: 3px;
    }
    .check_container:hover input ~ .check_checkmark {
        background-color: #ffffff;
    }
    .check_container input:checked ~ .check_checkmark {
        background-color: #212541;
    }
    .check_checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    .check_container input:checked ~ .check_checkmark:after {
        display: block;
    }
    .check_container .check_checkmark:after {
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: 1px solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
}
</style>
